<template>
    <div class="container-fluid">
        <div class="row">
            <TableListRepairRequest/>
        </div>
    </div>
</template>

<script setup>
import { ref, defineAsyncComponent } from 'vue'
import Swal from 'sweetalert2'

const TableListRepairRequest = defineAsyncComponent(() => import("@/components/theme/repair-request/TableListRepairRequest.vue"))
</script>